import {
  IDSK,
  SearchableResourceFilterInput,
  SearchableWorkspaceProductConnection,
  WorkspaceProduct,
} from "@examspark/types";

import GraphQLAPI from "../..";

export const createWorkspaceProduct = async (params: {
  product: WorkspaceProduct;
}) => {
  const result = await GraphQLAPI.client.query<{
    createWorkspaceProduct: WorkspaceProduct;
  }>({
    query: /* GraphQL */ `
      mutation CreateWorkspaceProduct($input: CreateWorkspaceProductInput!) {
        createWorkspaceProduct(input: $input) {
          id
          sk
        }
      }
    `,
    variables: {
      input: params.product,
    },
  });

  return result.data?.createWorkspaceProduct;
};

export const getWorkspaceProduct = async (key: IDSK) => {
  const result = await GraphQLAPI.client.query<{
    getWorkspaceProduct: WorkspaceProduct;
  }>({
    query: /* GraphQL */ `
      query GetWorkspaceProduct($input: ModelGetInput) {
        getWorkspaceProduct(input: $input) {
          id
          sk
          name
          workspaceId
          isDeleted
          isDisabled
          filter
        }
      }
    `,
    variables: {
      input: key,
    },
  });

  return result.data?.getWorkspaceProduct;
};

export const deleteWorkspaceProduct = async (
  item: Partial<WorkspaceProduct>,
) => {
  const result = await GraphQLAPI.client.query<{
    deleteWorkspaceProduct: WorkspaceProduct;
  }>({
    query: /* GraphQL */ `
      mutation DeleteWorkspaceProduct($input: DeleteWorkspaceProductInput!) {
        deleteWorkspaceProduct(input: $input) {
          id
          sk
        }
      }
    `,
    variables: {
      input: item,
    },
  });

  return result.data?.deleteWorkspaceProduct;
};

export const updateWorkspaceProduct = async (
  item: Partial<WorkspaceProduct>,
) => {
  const result = await GraphQLAPI.client.query<{
    updateWorkspaceProduct: WorkspaceProduct;
  }>({
    query: /* GraphQL */ `
      mutation UpdateWorkspaceProduct($input: UpdateWorkspaceProductInput!) {
        updateWorkspaceProduct(input: $input) {
          id
          sk
        }
      }
    `,
    variables: {
      input: item,
    },
  });

  return result.data?.updateWorkspaceProduct;
};

export const searchWorkspaceProducts = async (workspaceId: string) => {
  const filter: SearchableResourceFilterInput = {
    sk: {
      eq: "product",
    },
    workspaceId: {
      eq: workspaceId,
    },
  };

  const result = await GraphQLAPI.client.query<{
    searchWorkspaceProducts: SearchableWorkspaceProductConnection;
  }>({
    query: /* GraphQL */ `
      query SearchWorkspaceProducts(
        $filter: SearchableResourceFilterInput
        $sort: [SearchableResourceSortInput!]
        $limit: Int
        $nextToken: String
      ) {
        searchWorkspaceProducts(
          filter: $filter
          sort: $sort
          limit: $limit
          nextToken: $nextToken
        ) {
          items {
            id
            sk
            name
            workspaceId
            isDeleted
            isDisabled
          }
          nextToken
          total
          __typename
        }
      }
    `,
    variables: {
      filter,
    },
  });

  return result.data?.searchWorkspaceProducts;
};
